// @ts-nocheck
// Singleton Keycloak instance. Initialisation happens in
// components/Auth/KeycloakProvider.tsx — this file just constructs the
// keycloak-js client. Mock-auth and Playwright e2e token wiring is handled
// inside the Provider so this module stays a pure config artefact.
import Keycloak from 'keycloak-js';

export const ELECTRON_APP_ORIGIN = 'http://localhost:34115';

type KeycloakClientIdConfig = {
  appMode: boolean;
  viteClientId?: string;
  runtimeClientId?: string;
  origin: string;
};

export const resolveKeycloakClientId = ({
  appMode,
  viteClientId,
  runtimeClientId,
  origin,
}: KeycloakClientIdConfig): string | undefined => {
  if (appMode && origin === ELECTRON_APP_ORIGIN && viteClientId) {
    return viteClientId;
  }

  return runtimeClientId || viteClientId;
};

const keycloak = new Keycloak({
  url: 'https://auth.cern.ch/auth',
  realm: 'cern',
  // Electron app builds bake the prod client id at build time (VITE_KEYCLOAK_CLIENT_ID);
  // deployed web builds must read it at runtime from config/init.js (window.REACT_APP_*).
  clientId: resolveKeycloakClientId({
    appMode: import.meta.env.VITE_APP === 'true',
    viteClientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    runtimeClientId: window.REACT_APP_KEYCLOAK_CLIENT_ID,
    origin: window.location.origin,
  }),
});

export default keycloak;
